export const ELEMENTAL_PRODUCT_NAME = 'elemental';
export const ELEMENTAL_CLUSTER_PROVIDER = 'machineinventoryselectortemplate';

export const ELEMENTAL_SCHEMA_IDS = {
  MACHINE_INVENTORIES:            'elemental.cattle.io.machineinventory',
  MACHINE_INV_SELECTOR_TEMPLATES: 'elemental.cattle.io.machineinventoryselectortemplate',
};

export const KIND = { MACHINE_INV_SELECTOR_TEMPLATES: 'MachineInventorySelectorTemplate' };
